import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import { TrialBroadcastLimitAlert } from 'entities/Subscription/ui/TrialBroadcastLimitAlert'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IReviewBroadcastProps } from '../type'
import styles from './styles.module.scss'

export const ReviewAlerts: FC<IReviewBroadcastProps> = observer(({ store }) => {
  const {
    isNotEnoughCredits,
    notEnoughCredits,
    isOverDailyLimit,
    package_count,
    isRecurring,
    isAutoRechargeAlert,
    autoRechargeWidgetStore,
    close,
  } = store
  const { subscriptionStore, usersStore } = useEntitiesContext()
  const isMember = usersStore.user?.isMemberRole || usersStore.user?.isManagerRole

  const notEnoughCreditsLabel = numberFormat({
    value: Math.ceil(Number(notEnoughCredits.toFixed(4)) * 10) / 10,
  })

  let alert
  if (subscriptionStore.isTrial) {
    alert = <TrialBroadcastLimitAlert onCloseModal={close} />
  } else if (isNotEnoughCredits) {
    alert = isMember ? (
      <Alert
        item={{
          title: `You need ${notEnoughCreditsLabel} more credits to send your broadcast`,
          desc: 'Ask your organization owner to add message credits to your account',
          type: 'infoBlue',
        }}
      />
    ) : (
      <Alert
        item={{
          desc: `You need ${notEnoughCreditsLabel} more credits to send your broadcast`,
          type: 'infoBlue',
        }}
        actions={[
          {
            variant: 'button',
            type: 'primary',
            text: 'Enable auto-recharge',
            onClick: () => autoRechargeWidgetStore.openModal(),
          },
        ]}
      />
    )
  } else if (isAutoRechargeAlert) {
    alert = (
      <Alert
        item={{
          desc: 'To send your broadcast, please enable auto-recharge',
          type: 'infoBlue',
        }}
        actions={[
          {
            variant: 'button',
            type: 'primary',
            text: 'Enable auto-recharge',
            onClick: () => autoRechargeWidgetStore.openModal(),
          },
        ]}
      />
    )
  } else if (isOverDailyLimit) {
    alert = (
      <Alert
        item={{
          desc: `Your segment exceeds your daily limit of  ${numberFormat({
            value: package_count,
          })} messages per day and will be dripped over multiple days`,
          type: 'infoBlue',
        }}
      />
    )
  } else if (isRecurring) {
    alert = (
      <Alert
        item={{
          desc: 'The estimates apply only to the initial broadcast and do not account for any subsequent recurring broadcasts.',
          type: 'infoBlue',
        }}
      />
    )
  }
  if (!alert) return null
  return <div className={styles.wrap}>{alert}</div>
})
